import React, { useState } from 'react';
import Sidebar from './Sidebar.js';
import AdminHeader from './Header.js';
import { Card, Row, Col, Container, Form, Button } from 'react-bootstrap';
import Breadcrumb from './Breadcrumb.js';
import Select from 'react-select';
import occupations from './data/occupations.js';
import industriesData from './data/industries';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const MappingOccupation = () => {
    
    const navigate = useNavigate();

    const [industries, setIndustries] = useState([
        { industry: '', subIndustry: '', subSubIndustry: '' },
    ]);

    const [selectedOccupation, setSelectedOccupation] = useState(null);
    const [selectedSubOccupation, setSelectedSubOccupation] = useState(null); // 2-digit
    const [selectedMinorOccupation, setSelectedMinorOccupation] = useState(null); // ✅ 3-digit
    const [selectedJobRole, setSelectedJobRole] = useState(null); // ✅ 4-digit

    const handleIndustryChange = (index, key, value) => {
        const updated = [...industries];
        updated[index][key] = value;
      
        // Reset dependent dropdowns when parent changes
        if (key === 'industry') {
          updated[index].subIndustry = '';
          updated[index].subSubIndustry = '';
        }
        if (key === 'subIndustry') {
          updated[index].subSubIndustry = '';
        }
      
        setIndustries(updated);
      };

    const onAddIndustry = () => {
        setIndustries(prev => [...prev, { industry: '', subIndustry: '' }]); // ✅
    };
    
    const onRemoveIndustry = () => {
        if (industries.length > 1) {
            setIndustries(prev => prev.slice(0, -1)); // ✅ Remove last one
        }
    };

    const handleOccupationChange = (code) => {
        const occ = occupations.find(o => o.code === code);
        setSelectedOccupation(occ || null);
        setSelectedSubOccupation(null); // Reset sub selection
    };

    const handleSubOccupationChange = (code) => {
        let found = null;
      
        const findRecursively = (nodes) => {
          for (const node of nodes) {
            if (node.code === code) return node;
            if (node.children) {
              const sub = findRecursively(node.children);
              if (sub) return sub;
            }
          }
          return null;
        };
      
        found = selectedOccupation ? findRecursively(selectedOccupation.children || []) : null;
        setSelectedSubOccupation(found || null);
        setSelectedMinorOccupation(null);
    };

    const handleMinorOccupationChange = (code) => {
        let found = null;
    
        const findInMinorGroups = (nodes) => {
            for (const node of nodes) {
                if (node.children) {
                    for (const minor of node.children) {
                        if (minor.code === code) return minor;
                    }
                }
            }
            return null;
        };
    
        found = selectedOccupation ? findInMinorGroups(selectedOccupation.children || []) : null;
        setSelectedMinorOccupation(found || null);
    };

    const handleJobRoleChange = (code) => {
        let found = null;
    
        const findInJobRoles = (nodes) => {
            for (const node of nodes) {
                if (node.children) {
                    for (const minor of node.children) {
                        if (minor.children) {
                            for (const unit of minor.children) {
                                if (unit.code === code) return unit;
                            }
                        }
                    }
                }
            }
            return null;
        };
    
        found = selectedSubOccupation ? findInJobRoles([selectedSubOccupation]) : null;
        setSelectedJobRole(found || null);
    };

    const handleSave = async () => {
        if (!selectedOccupation || !selectedSubOccupation || !selectedMinorOccupation || !selectedJobRole) {
          alert('Please select all occupation levels.');
          return;
        }
      
        if (!industries.length || industries.some(ind => !ind.industry || !ind.subIndustry)) {
          alert('Please complete all industry selections.');
          return;
        }
      
        const payload = {
          occupationMajor: {
            code: selectedOccupation.code,
            title: selectedOccupation.title,
          },
          occupationSub: {
            code: selectedSubOccupation.code,
            title: selectedSubOccupation.title,
          },
          occupationMinor: {
            code: selectedMinorOccupation.code,
            title: selectedMinorOccupation.title,
          },
          occupationJobRole: {
            code: selectedJobRole.code,
            title: selectedJobRole.title,
          },
          industries: industries.map(({ industry, subIndustry }) => ({
            industry,
            subIndustry
          }))
        };
      
        try {
          await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/occupations`,
            payload,
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          );
          alert('Occupation mapping saved successfully.');
          navigate('/mapping-overview');
        } catch (error) {
          console.error('Failed to save mapping:', error);
          alert('Failed to save mapping. Check console for details.');
        }
    }; 

    return (
        <>
            <AdminHeader />
            <Container className="pt-2">
                <Row>
                    <Col xs={2} className="p-0">
                    </Col>
                    <Col xs={10} className="p-0">
                        <Breadcrumb />
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row>
                    <Col xs={3} className="p-0">
                        <Sidebar />
                    </Col>

                    <Col xs={9} className="p-4">
                        <Card>
                            <Card.Body>
                                <h1 className="mb-3">Mapping 2 - Occupation mapping</h1>
                                <Row className="mb-4">
                                    <Col>
                                        <Card className="mb-3">
                                            <Card.Body>
                                                <Row className="mb-4">
                                                    <Col md={12}>
                                                        <label>Occupation Major Group *</label>
                                                        <Select
                                                        options={occupations.map(occ => ({
                                                            value: occ.code,
                                                            label: occ.title,
                                                        }))}
                                                        value={
                                                            selectedOccupation?.code
                                                            ? { value: selectedOccupation.code, label: selectedOccupation.title }
                                                            : null
                                                        }
                                                        onChange={(selected) => handleOccupationChange(selected?.value || '')}
                                                        isClearable
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={12}>
                                                        <label>Sub Occupation Group *</label>
                                                        <Select
                                                            options={
                                                                selectedOccupation?.children
                                                                ? selectedOccupation.children.map(sub => ({
                                                                    value: sub.code,
                                                                    label: sub.title
                                                                    }))
                                                                : []
                                                                }
                                                            value={
                                                                selectedSubOccupation
                                                                ? {
                                                                    value: selectedSubOccupation.code,
                                                                    label: selectedSubOccupation.title,
                                                                    }
                                                                : null
                                                            }
                                                            onChange={(selected) => handleSubOccupationChange(selected?.value || '')}
                                                            isClearable
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={12}>
                                                        <label>Occupation Minor Group *</label>
                                                        <Select
                                                            options={
                                                                selectedSubOccupation?.children
                                                                  ? selectedSubOccupation.children.map(minor => ({
                                                                      value: minor.code,
                                                                      label: minor.title
                                                                    }))
                                                                  : []
                                                            }
                                                            value={
                                                                selectedMinorOccupation
                                                                  ? { value: selectedMinorOccupation.code, label: selectedMinorOccupation.title }
                                                                  : null
                                                              }
                                                            onChange={(selected) => handleMinorOccupationChange(selected?.value || '')}
                                                            isClearable
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={12}>
                                                        <label>Occupation Job Role *</label>
                                                        <Select
                                                            options={
                                                                selectedMinorOccupation?.children
                                                                    ? selectedMinorOccupation.children.map(unit => ({
                                                                        value: unit.code,
                                                                        label: unit.title
                                                                    }))
                                                                    : []
                                                            }
                                                            value={
                                                                selectedJobRole
                                                                    ? { value: selectedJobRole.code, label: selectedJobRole.title }
                                                                    : null
                                                            }
                                                            onChange={(selected) => handleJobRoleChange(selected?.value || '')}
                                                            isClearable
                                                        />
                                                    </Col>
                                                </Row>

                                            </Card.Body>
                                        </Card>

                                    </Col>
                                    <Col>
                                        <Card className="mb-3">
                                            <Card.Body>
                                                {industries.map((industry, index) => {
                                                    const selectedIndustry = industriesData.find(ind => ind.code === industry.industry);

                                                    return (
                                                        
                                                        <Row className="mb-4" key={index}>
                                                            <Col md={4}>
                                                                <label>Industry *</label>
                                                                <Select
                                                                    options={industriesData.map(ind => ({
                                                                        value: ind.code,
                                                                        label: ind.name,
                                                                    }))}
                                                                    value={
                                                                        industry.industry
                                                                        ? {
                                                                            value: industry.industry,
                                                                            label: industriesData.find(ind => ind.code === industry.industry)?.name,
                                                                            }
                                                                        : null
                                                                    }
                                                                    onChange={selected =>
                                                                        handleIndustryChange(index, 'industry', selected?.value || '')
                                                                    }
                                                                    isClearable
                                                                />
                                                            </Col>

                                                            <Col md={4}>
                                                                <label>Sub Industry *</label>
                                                                <Select
                                                                options={
                                                                    selectedIndustry?.subIndustries.map(sub => ({
                                                                    value: sub.code,
                                                                    label: sub.name,
                                                                    })) || []
                                                                }
                                                                value={
                                                                    selectedIndustry?.subIndustries.find(sub => sub.code === industry.subIndustry)
                                                                    ? {
                                                                        value: industry.subIndustry,
                                                                        label: selectedIndustry.subIndustries.find(sub => sub.code === industry.subIndustry)?.name,
                                                                        }
                                                                    : null
                                                                }
                                                                onChange={selected =>
                                                                    handleIndustryChange(index, 'subIndustry', selected?.value || '')
                                                                }
                                                                isClearable
                                                                />
                                                            </Col>

                                                            <Col md={4}>
                                                                <label>Sub Sub Industry</label>
                                                                <Select
                                                                options={
                                                                    selectedIndustry?.subIndustries.find(sub => sub.code === industry.subIndustry)
                                                                    ?.subSubIndustries?.map(subSub => ({
                                                                        value: subSub.code,
                                                                        label: subSub.name,
                                                                    })) || []
                                                                }
                                                                value={
                                                                    selectedIndustry?.subIndustries
                                                                    .find(sub => sub.code === industry.subIndustry)
                                                                    ?.subSubIndustries?.find(subSub => subSub.code === industry.subSubIndustry)
                                                                    ? {
                                                                        value: industry.subSubIndustry,
                                                                        label: selectedIndustry.subIndustries
                                                                            .find(sub => sub.code === industry.subIndustry)
                                                                            .subSubIndustries.find(subSub => subSub.code === industry.subSubIndustry)?.name,
                                                                        }
                                                                    : null
                                                                }
                                                                onChange={selected =>
                                                                    handleIndustryChange(index, 'subSubIndustry', selected?.value || '')
                                                                }
                                                                isClearable
                                                                />
                                                            </Col>
                                                        </Row>
                                                    );
                                                })}
                                                <Row>
                                                    <Col className="d-flex justify-content-end gap-2">
                                                        <Button variant="danger" onClick={onRemoveIndustry}>
                                                            Remove
                                                        </Button>
                                                        <Button variant="primary" onClick={onAddIndustry}>
                                                            Add New
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-end gap-2 px-4">
                        <Button variant="secondary" onClick={() => navigate('/mapping-overview')}>
                            Back
                        </Button>
                        <Button variant="primary" onClick={handleSave}>
                            Save
                        </Button>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default MappingOccupation;
